import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Grid from '@material-ui/core/Grid'
import Hidden from '@material-ui/core/Hidden'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Link, { navigateTo } from 'gatsby-link'
import get from 'lodash/get'
import React from 'react'
import Helmet from 'react-helmet'
import BlogDateAuthor from '../components/Blog/BlogDateAuthor'
import BlogSidebar from '../components/Blog/BlogSidebar'
import favicon from '../components/images/favicon.png'
import logo from '../components/images/logo-autoclub.png'

const styles = theme => ({
  container: {
    width: '70%',
    [theme.breakpoints.down('lg')]: {
      width: '75%',
    },
    [theme.breakpoints.down('md')]: {
      width: '88%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '92%',
    },
    margin: '0 auto',
    padding: '40px 0',
  },
  red: {
    color: theme.palette.primary.second,
  },
  grid: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      flexBasis: '100%',
    },
  },
  mainTitle: {
    color: theme.palette.primary.main,
    marginLeft: 20,
  },
  media: {
    paddingTop: '56.25%',
    backgroundSize: 'cover',
  },
  link: {
    textDecoration: 'none',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  verticalDivider: {
    borderLeft: '1px solid black',
    height: 775,
    borderColor: '#9e9e9e',
    marginLeft: 38,
    [theme.breakpoints.down('md')]: {
      marginLeft: 25,
      height: 875,
    },
  },
  card: {
    marginBottom: 36,
    '&:hover': {
      boxShadow: '0px 4px 12px 0px rgba(0,0,0,0.5)',
      transition: 'all .25s linear',
      cursor: 'pointer',
    },
  },
})

class BlogArticles extends React.Component {
  render() {
    const { classes } = this.props
    const posts = get(this, 'props.data.allContentfulBlogArticle.edges')
    const edges = this.props.data.allContentfulBlogArticle.edges
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')

    return (
      <div className={classes.container}>
        <Helmet>
          <title>{siteTitle}</title>
          <link rel="icon" type="favicon" href={favicon} sizes="16x16" />
        </Helmet>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <img src={logo} width={64} height={37} />
            <h2 className={classes.mainTitle}>Auto Club Blog</h2>
          </div>
          <div style={{ display: 'flex' }}>
            <Grid container spacing={24}>
              {posts.map(({ node }) => {
                return (
                  <Grid
                    item
                    xs={12}
                    key={node.slug}
                    component={Link}
                    to={node.slug}
                    style={{
                      textDecoration: 'none',
                    }}
                  >
                    <Card
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        textDecoration: 'none',
                      }}
                      className={classes.card}
                    >
                      <CardMedia
                        image={node.image.responsiveResolution.src}
                        title={node.title}
                        style={{ paddingTop: '35.25%' }}
                      />
                      <div
                        style={{
                          flex: 1,
                          marginBottom: 'auto',
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <CardContent>
                          <div onClick={() => navigateTo(node.slug)}>
                            <Typography variant="headline" component="div">
                              {node.title}
                            </Typography>
                          </div>
                          <Typography component="div">
                            <p
                              dangerouslySetInnerHTML={{
                                __html:
                                  node.article.childMarkdownRemark.excerpt,
                              }}
                            />
                          </Typography>
                        </CardContent>
                        <BlogDateAuthor post={node} />
                      </div>
                    </Card>
                  </Grid>
                )
              })}
            </Grid>
            <div style={{ display: 'flex' }}>
              <Hidden smDown>
                <div className={classes.verticalDivider} />
                <BlogSidebar />
              </Hidden>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(BlogArticles)

export const pageQuery = graphql`
  query pageQueryBlogArticles {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulBlogArticle(
      filter: { node_locale: { eq: "en-US" } }
      sort: { fields: [date], order: DESC }
    ) {
      edges {
        node {
          id
          slug
          date
          title
          image {
            responsiveResolution(width: 1600, height: 900) {
              src
            }
          }
          article {
            id
            childMarkdownRemark {
              excerpt(pruneLength: 500)
              html
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/blog.js